import { WatcherFunction } from '..'
import { watchMediaObjectLicenseOptionsRequest } from './mediaObjectLicenseOptions'

export const licensesSagas: ReadonlyArray<WatcherFunction> = [watchMediaObjectLicenseOptionsRequest]
